export const RATE_LIMITS = {
  MATCHES_PER_DAY: 100,
  DAILY_BOX_COOLDOWN_MS: 20 * 60 * 60 * 1000, // 20 hours
  INIT_DATA_MAX_AGE_SEC: 86400, // 24h — initData is generated once when TMA opens
  MIN_ACCOUNT_AGE_DAYS_FOR_PAYOUT: 30,
} as const;

export const CURRENCIES = {
  SOFT: "soft",
  HARD: "hard",
} as const;

export const LEAGUES = {
  MIN: 1,
  MAX: 7,
  NAMES: ["Bronze", "Silver", "Gold", "Platinum", "Diamond", "Master", "Legend"],
  XP_THRESHOLDS: [0, 100, 300, 600, 1000, 1500, 2200, 3000],
} as const;

export const XP_REWARDS = {
  WIN: 10,
  LOSE: 2,
  SOFT_WIN: 50,
  SOFT_LOSE: 10,
} as const;

export const DAILY_LEADERBOARD = {
  REWARDS: [50, 30, 20] as const,
  BASE_POINTS: 10,
  STREAK_BONUS_PER_WIN: 2,
  MAX_STREAK_BONUS: 10,
  PREMIUM_MULTIPLIER: 2,
} as const;

export const API_ROUTES = {
  PLAYER_AUTH: "/api/player/auth",
  PLAYER_ME: "/api/player/me",
  MATCH_SUBMIT: "/api/match/submit",
  DAILY_BOX_STATUS: "/api/daily-box/status",
  DAILY_BOX_CLAIM: "/api/daily-box/claim",
  LEADERBOARD_GLOBAL: "/api/leaderboard/global",
  LEADERBOARD_WEEKLY: "/api/leaderboard/weekly",
  LEADERBOARD_ME: "/api/leaderboard/me",
  HEALTH: "/health",
  SHOP_CATALOG: "/api/shop/catalog",
  SHOP_CREATE_INVOICE: "/api/shop/create-invoice",
  PLAYER_SYNC: "/api/player/sync",
  SHOP_VERIFY_PAYMENT: "/api/shop/verify-payment",
  CONFIG: "/api/config",
  ADMIN_CATALOG: "/api/admin/catalog",
  ADMIN_CONFIG: "/api/admin/config",
  ADMIN_USERS: "/api/admin/users",
  ADMIN_STATS: "/api/admin/stats",
  SHOP_UNLOCK_BOOSTER: "/api/shop/unlock-booster",
  SHOP_PURCHASE: "/api/shop/purchase",
  REFERRAL_INFO: "/api/referral/info",
  REFERRAL_CLAIM: "/api/referral/claim",
  REFERRAL_PREPARE_SHARE: "/api/referral/prepare-share",
  PLAYER_CLAIM_REFERRAL_GIFT: "/api/player/claim-referral-gift",
  SHOP_PURCHASE_TON: "/api/shop/purchase-ton",
  TON_DEPOSIT_STATUS: "/api/ton/status",
  TON_RATE: "/api/ton/rate",
  TON_WEBHOOK: "/api/ton/webhook",
  PLAYER_TRANSACTIONS: "/api/player/transactions",
  LEADERBOARD_DAILY: "/api/leaderboard/daily",
  LEADERBOARD_DAILY_ME: "/api/leaderboard/daily/me",
  LEADERBOARD_DAILY_CLAIM: "/api/leaderboard/daily/claim",
  SHOP_PURCHASE_TRIBUTE: "/api/shop/purchase-tribute",
  TRIBUTE_DEPOSIT_STATUS: "/api/tribute/status",
  TRIBUTE_WEBHOOK: "/api/tribute/webhook",
  EVENTS: "/api/events",
  ADS_REWARDED_COMPLETE: "/api/ads/rewarded-complete",
  ADS_CONTINUE: "/api/ads/continue",
  ADS_PREMIUM_CLAIM: "/api/ads/premium-claim",
  ADS_DAILY_PROGRESS: "/api/ads/daily-progress",
  FUNNEL_EVENT: "/api/funnel/event",
  ADMIN_FUNNEL: "/api/admin/funnel",
  ADMIN_UTM: "/api/admin/utm",
  ADMIN_PAYMENTS_FUNNEL: "/api/admin/payments/funnel",
  ADMIN_PAYMENTS_TOUCHPOINTS: "/api/admin/payments/touchpoints",
} as const;
